<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="财务手工编辑"
      width="620px"
      top="12vh"
      append-to-body
      @close="$reset('form')">
    <el-form ref="form" :model="form" :rules="ruleValidate" label-width="110px">
      <el-form-item label="组织" prop="departmentName">
        <div style="display: flex;flex-direction: row;">
          <el-input v-model="form.departmentName" placeholder="请输入" readonly>
            <el-button slot="append" icon="el-icon-search" @click="$refs.selectDepartment.open()">选择组织</el-button>
          </el-input>
          <department-select ref="selectDepartment" @select="selectDepartment"/>
        </div>
      </el-form-item>
      <el-form-item label="期间" prop="periodDate">
        <el-date-picker
            v-model="form.periodDate"
            value-format="yyyy-MM-dd"
            type="month"
            placeholder="选择期间"
            style="width: 100%"/>
      </el-form-item>
      <el-form-item label="编辑类型" prop="editType">
        <el-select v-model="form.editType" placeholder="请选择" style="width: 100%">
          <el-option :value="1" label="目标"/>
          <el-option :value="2" label="增减收入"/>
          <el-option :value="3" label="已签收调整"/>
        </el-select>
      </el-form-item>
      <el-form-item label="原值" prop="oldValue">
        <el-input-number v-model="form.oldValue" :precision="2" :min="0" :controls="false" style="width: 100%"/>
      </el-form-item>
      <el-form-item label="新值" prop="newValue">
        <el-input-number v-model="form.newValue" :precision="2" :min="0" :controls="false" style="width: 100%"/>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.remark" type="textarea" :rows="2" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import DepartmentSelect from "@/views/information/Department/DepartmentSelect";

  export default {
    name: "ManualEditDialog",
    components: {DepartmentSelect},
    data() {
      return {
        dialogVisible: false,
        submitLoading: false,
        form: {
          pkid: null,
          orgLevel: 3,
          departmentId: null,
          departmentName: "",
          periodDate: "",
          editType: 1,
          oldValue: 0,
          newValue: 0,
          remark: "",
        },
        ruleValidate: {
          departmentName: {required: true, message: "请选择组织", trigger: "blur"},
          periodDate: {required: true, message: "请选择期间", trigger: "change"},
          editType: {required: true, message: "请选择编辑类型", trigger: "change"},
        },
      };
    },
    methods: {
      open() {
        this.form.pkid = null;
        this.form.departmentId = null;
        this.form.departmentName = "";
        this.form.periodDate = "";
        this.form.editType = 1;
        this.form.oldValue = 0;
        this.form.newValue = 0;
        this.form.remark = "";
        this.dialogVisible = true;
      },
      selectDepartment(row) {
        this.form.departmentId = row.departmentID;
        this.form.departmentName = row.departmentName;
      },
      handleSubmit() {
        this.$refs.form.validate(valid => {
          if (!valid) {
            return;
          }
          this.submitLoading = true;
          this.$http
            .post("basic", "sd/salesRevenueReport/manualEdit", this.form)
            .then(resp => {
              this.submitLoading = false;
              if (resp && resp.success === false) {
                return this.$message.error(resp.message || "保存失败");
              }
              this.dialogVisible = false;
              this.$message.success("保存成功");
              this.$emit("save-success");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
